import { AbstractControl, ValidatorFn } from '@angular/forms';
import { parse, endOfMonth, getMonth, getYear, isValid } from 'date-fns';

export function invalidCardExpirationDate(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const inputDate = parse(control.value, 'MM/yy', new Date());
    const currentDate = endOfMonth(new Date());

    const inputMonth = getMonth(inputDate);
    const inputYear = getYear(inputDate);

    const currentMonth = getMonth(currentDate);
    const currentYear = getYear(currentDate);

    if (
      !isValid(inputDate) ||
      inputYear < currentYear ||
      (inputYear === currentYear && inputMonth < currentMonth)
    ) {
      return { invalidCardExpirationDate: true };
    }

    return null;
  };
}
